var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChadhava1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Solid",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.129 38.185a2 2 0 0 0 -3.191-.618l-7.625 7.2a1 1 0 0 0 -.013 1.44l13.673 13.5a1 1 0 0 0 1.476-.078l2.759-3.37a2 2 0 0 0 .269-2.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51.84 4a7.841 7.841 0 0 0 -7.2 4.734l8.7 3.166a1.1 1.1 0 0 1 .16.074 5.028 5.028 0 0 1 2.5 4.338v14.231a6.979 6.979 0 0 1 3 2.505 3 3 0 0 1 -.828 4.166l-2.172 1.446v6.36a4 4 0 0 0 8-.02v-28.84a12.16 12.16 0 0 0 -12.16-12.16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m57.337 34.163a4.782 4.782 0 0 0 -6.5-1.381l-11.071 6.931h-12.755a1 1 0 1 1 0-2h9.489a3 3 0 0 0 0-6h-14.018a11 11 0 0 0 -7.552 3l-2.23 2.107 6.772 14.729 1.5-1.839 12.112.005a8.984 8.984 0 0 0 4.994-1.515l18.982-12.65a1 1 0 0 0 .277-1.387z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 34.713a4.951 4.951 0 0 1 -.316 1.749l7.156-4.48 1.488-2a10.679 10.679 0 0 0 .482-12.142l2.163-2.726a1 1 0 0 0 -.442-1.562l-17.541-6.384a1 1 0 0 0 -1.341.913l-.095 3.479a10.678 10.678 0 0 0 -7.44 9.61l-.493 8.543h11.379a5.006 5.006 0 0 1 5 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChadhava1);
export default __webpack_public_path__ + "static/media/Chadhava_1.98c95969c938f0fa70f1da6d9f5b812e.svg";
export { ForwardRef as ReactComponent };